import blurCSS from '../styles/blur.css';
import {createStyleNode} from './utils';

class ContentBlurRenderer {
    constructor(scope) {
        this.scope = scope;
    }

    configure(options) {
        this.autoBlur = options.autoBlur;

        if (this.autoBlur) {
            this.style = createStyleNode(this.scope, blurCSS);
        }
    }

    render() {
        if (this.autoBlur) {
            const target = this.scope.document;

            if (!target.head) {
                console.error('[AGEGO] missing <head>, auto-blur failed');
                return;
            }

            target.head.appendChild(this.style);

            if (!target.body) {
                const listener = () => {
                    this.scope.document.removeEventListener('DOMContentLoaded', listener);
                    this.bodyBlurClassAttach();
                };

                this.scope.document.addEventListener('DOMContentLoaded', listener, false);
                return;
            }

            this.bodyBlurClassAttach();
        }
    }

    destroy() {
        if (!this.autoBlur) {
            return;
        }

        const target = this.scope.document;

        target.body.className = target.body.className
            .replaceAll('agego-blur-content', '')
            .trim();

        target.head.removeChild(this.style);
    }

    bodyBlurClassAttach() {
        if (-1 !== this.scope.document.body.className.indexOf('agego-blur-content')) {
            return;
        }

        this.scope.document.body.className = (this.scope.document.body.className + ' agego-blur-content').trim();
    }
}

export {ContentBlurRenderer};
